var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.937,
    height: 10.349,
    viewBox: "0 0 12.937 10.349",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "mail",
    d: "M13,4H3.94A1.94,1.94,0,0,0,2,5.94v6.468a1.94,1.94,0,0,0,1.94,1.94H13a1.94,1.94,0,0,0,1.94-1.94V5.94A1.94,1.94,0,0,0,13,4Zm-.433,1.294L8.468,8.366,4.374,5.294ZM13,13.056H3.94a.647.647,0,0,1-.647-.647V6.1L8.08,9.692a.647.647,0,0,0,.776,0L13.643,6.1v6.307A.647.647,0,0,1,13,13.056Z",
    transform: "translate(-2 -4)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.b5f7b02a4a51508aec6a37d151635a63.svg";
export { ForwardRef as ReactComponent };